import { css } from '@emotion/core';
import { media, variables as vars } from '@domain-group/fe-brary';
var font = /*#__PURE__*/css("font-family:", vars.font.bodyFontFamily, ";font-size:", vars.font.smallFontSize, ";color:", vars.colour.neutral700, ";", media('>=desktop'), "{font-size:", vars.font.baseFontSize, ";}");
export var container = {
  name: "4u674b",
  styles: "display:block;margin:5px 0;padding:0;"
};
export var item = {
  name: "1xasier",
  styles: "display:block;margin:0;padding:0;"
};
var _ref = {
  name: "1fqlzze",
  styles: "line-height:2em;padding:0 15px;"
};
var _ref2 = {
  name: "1gk4ta0",
  styles: "padding:10px 15px;"
};
export var subheading = _ref5 => {
  var _ref5$radio = _ref5.radio,
    radio = _ref5$radio === void 0 ? false : _ref5$radio,
    _ref5$indented = _ref5.indented,
    indented = _ref5$indented === void 0 ? false : _ref5$indented;
  return /*#__PURE__*/css(font, ";font-weight:", vars.font.headingFontWeight, ";display:block;", indented && _ref, " ", radio && _ref2);
};
var _ref3 = {
  name: "osn4vg",
  styles: "padding-left:30px;"
};
export var button = _ref6 => {
  var _ref6$selected = _ref6.selected,
    selected = _ref6$selected === void 0 ? false : _ref6$selected,
    _ref6$indented = _ref6.indented,
    indented = _ref6$indented === void 0 ? false : _ref6$indented;
  return /*#__PURE__*/css(font, ";line-height:32px;display:block;background:none;border:0;outline:none;margin:0;padding:0 15px;cursor:pointer;width:100%;text-align:left;", selected && /*#__PURE__*/css("background:", vars.colour.neutral100, ";"), " ", indented && _ref3, " &:hover{background:", vars.colour.neutral200, ";}");
};
var _ref4 = {
  name: "osn4vg",
  styles: "padding-left:30px;"
};
export var radio = function radio() {
  var indented = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return /*#__PURE__*/css(font, ";margin:0;padding:10px 15px;", indented && _ref4);
};